import React from 'react';

const DirectionsBlock = ({ block }) => {
  if (!block.text) return null;

  const style = block.style || {};
  const requirementStyle = block.style?.requirementStyle || {};

  const getRequirementText = () => {
    if (!block.requirement) return null;
    let text = block.requirement.text || '';
    if (block.requirement.passingScore) {
      text = text.replace('{passingScore}', block.requirement.passingScore);
    }
    return text;
  };

  return (
    <div className={`${style.borderLeft || 'border-l-4'} ${style.borderColor || 'border-gray-300'} ${style.padding || 'pl-4'} ${style.textColor || 'text-gray-800'} mb-6`}>
      <p className="mb-2">{block.text}</p>
      {block.requirement && (
        <p className={`${requirementStyle.italic ? 'italic' : ''} ${requirementStyle.textColor || 'text-gray-600'} ${requirementStyle.fontSize || 'text-sm'} mt-2`}>
          {getRequirementText()}
        </p>
      )}
    </div>
  );
};

export default DirectionsBlock;

